import appointment_reminder from "../assets/appointment_reminder.png";
import policy_link_success from "../assets/policy_link_success.png";
import appointment_success from "../assets/appointment_success.png";
import appointment_failure from "../assets/appointment_failure.png";
import policy_link_failed from "../assets/policy_link_failed.png";
import loa_success from "../assets/loa_success.png";
import loa_failure from "../assets/loa_failure.png";
import system from "../assets/system.png";

export const server_error_title = "Oops! Something's not right";
export const server_error_message =
  "We apologize for the inconvenience. It looks like we are currently experiencing a hiccup. Please try again in a few moments. Thank you for your patience and understanding.";

export const notifIcons = {
  ConsultationAppointment: appointment_reminder,
  MedicalTestAppointment: appointment_reminder,
  LOASuccess: loa_success,
  LOAFailure: loa_failure,
  System: system,
  // ContactNumberChange: loa_failure,
  // EmailChange: loa_failure,
  PolicySuccess: policy_link_success,
  PolicyFailure: policy_link_failed,
  Maintenance: system,
  MedicalTestAppointmentFailure: appointment_failure,
  MedicalTestAppointmentSuccess: appointment_success,
  ConsultationAppointmentFailure: appointment_failure,
  ConsultationAppointmentSuccess: appointment_success,
};
